import React from "react";

export const AngleLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.0003 17.0003C13.7443 17.0003 13.4883 16.9023 13.2933 16.7073L9.29325 12.7073C8.90225 12.3163 8.90225 11.6842 9.29325 11.2933L13.2933 7.29325C13.6842 6.90225 14.3163 6.90225 14.7073 7.29325C15.0983 7.68425 15.0983 8.31631 14.7073 8.70731L11.4143 12.0003L14.7073 15.2933C15.0983 15.6842 15.0983 16.3163 14.7073 16.7073C14.5123 16.9023 14.2563 17.0003 14.0003 17.0003Z"
      fill="black"
    />
  </svg>
);
